import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/styles/makeStyles';
import { useTranslation } from 'utils/modifiedTranslation';

const useStyles = makeStyles((theme) => ({
  root: {
    // color: '#324158',
    fontSize: 16,
    marginBottom: 10,
    fontStyle: 'italic',
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
}));

/**
 * Title of a question
 */
const QuestionSubTitle = (props) => {
  const { label } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  return <Typography variant="h4" className={classes.root} dangerouslySetInnerHTML={{ __html: t(label) }} />;
};

QuestionSubTitle.propTypes = {
  /**
   * Subtitle label
   */
  label: PropTypes.string.isRequired,
};

export default QuestionSubTitle;
